import { render, staticRenderFns } from "./CustomColumn.vue?vue&type=template&id=77d4d0d2&scoped=true"
import script from "./CustomColumn.vue?vue&type=script&lang=js"
export * from "./CustomColumn.vue?vue&type=script&lang=js"
import style0 from "./CustomColumn.vue?vue&type=style&index=0&id=77d4d0d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d4d0d2",
  null
  
)

export default component.exports